import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	openIconLabel: {
		id: 'project-settings-apps.avatar-modal.open-icon-label',
		defaultMessage: 'Open link',
		description: 'Icon label',
	},
});
